import $ from 'jquery'
import Vue from "vue";
const vueHeader = {};

vueHeader.init = () => {
    $("body").addClass("is-loaded");
    window.Menu = new Vue({
        el: "#header",
        data: {
            isReduced: false,
            navOpened: false,
            searchOpened: false,
            isMobile:false,
            toggledNav: true,
            scrollPosition: 0,
            breakPoint: 769,
            heightHeader: $('#header').outerHeight()
        },
        methods: {
            updateScroll: function() {
                this.scrollPosition = window.scrollY;

                // if ($('body').hasClass('home')) {
                    
                    if ($(window).width() >= this.breakPoint) { 

                        if ($('body').hasClass('home')) {

                            if (this.scrollPosition >= this.heightHeader) {
                                this.isReduced = true;
                                $(".cscontent").css({
                                    'paddingTop': this.heightHeader
                                });
                            } else {
                                this.isReduced = false;
                                $(".cscontent").css({
                                    'paddingTop': 0
                                });
                            }
                        }
                    } else {
                        this.isReduced = true;
                        this.navOpened = false;
                        this.isMobile = true;
                    }
                // }

                // if ($(window).width() < this.breakPoint) {
                //     this.isMobile = true;
                // }
            },

            toggleNav: function() {
                this.toggledNav = !this.toggledNav;
                if (this.isMobile) {
                    this.searchOpened = true;
                    $('html').addClass("no-scroll");
                }
                if (this.toggledNav) {
                    this.searchOpened = false;
                }
                if (this.toggledNav == true) {
                    $('html').removeClass("no-scroll");
                }
            },
            openSearch: function() {
                this.searchOpened = true;
            },
            closeSearch: function() {
                this.searchOpened = false;
                $('body').removeClass("open-search");
                if (this.isMobile) {
                    $('html').removeClass("no-scroll");
                }
            },
            toggleSearch: function() {
                this.searchOpened ? this.closeSearch() : this.openSearch();
            },
            openSubNav: function(event) {
                if (!this.isMobile) {
                    $(event.target).next().slideDown();
                }
            },
            closeSubNav: function(event) {
                if (!this.isMobile) {
                    $(event.target).children('ul').slideUp();
                }
            }
        },
        mounted() {
            window.addEventListener('scroll', this.updateScroll);
          },

    });
};
export default vueHeader;